var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',{staticClass:"title"},[_vm._v("Talki")]),_c('h1',[_vm._v("404-Página no encontrada")]),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.goToRoute()}}},[_vm._v("Regresar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }